import { CustomTableHeader } from '../../../../components/CustomTable';
import {
  renderComponenteAF,
  renderStatusExecucao,
} from '../ProcessosLicitatorios/auxiliarProcessosLicitatorios';

export const valoresExibidosOffCanvasActs: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separadorLog: '',
  separadorPontuacao: '',
  separadorIdentificacao: '',
  separadorFuncionalidade: '',
  separadorObservacoes: '',

  //Específicos
  statusAct: 'Status',
  componenteAf: 'Componente AF',
  dataDou: 'Data DOU',
  dataInicio: 'Data de Início',
  dataVigencia: 'Data de Vigência',
  numeroAct: 'Nº do ACT',
  fornecedor: 'Fornecedor',
  nProdutos: 'Nº de Produtos',
  valorTotal: 'Valor Total R$',
};

export const headersActs = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 5, key: 'id' },
  { text: 'Status', width: 12, key: 'statusAct' },
  { text: 'Componente', width: 12, key: 'componenteAf' },
  { text: 'Nº do ACT', width: 10, key: 'numeroAct' },
  { text: 'Fornecedor', width: 25, key: 'fornecedor' },
  { text: 'N Produtos', width: 10, key: 'nProdutos' },
  { text: 'Valor Total R$', width: 10, key: 'valorTotal' },
];

export const fieldObjectActs = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];

export const headersActsPartes = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'CNPJ', width: 15, key: 'cnpj' },
  { text: 'Razão Social', width: 80, key: 'razaoSocial' },
];

export const valoresExibidosOffCanvasActsPartes: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separadorLog: '',
  separadorPontuacao: '',
  separadorIdentificacao: '',
  separadorFuncionalidade: '',
  separadorObservacoes: '',

  //Específicos
  interfaceSisAf: 'Interface',
  moduloSisAf: 'Módulo',
  tipoTask: 'Tipo de Task',
  responsavel: 'Responsável',
  dataEntrada: 'Data de Início',
  dataFinalizacao: 'Data Finalização',
  diasDev: 'Total de dias',
  funcionalidade: 'Funcionalidade',
  descricao: 'Descrição',
  complexidade: 'Complexidade',
  reaproveitamentoCodigo: 'Reaprov. Código',
  pontosFuncionalidade: 'Level (0 a 100)',
  statusDesenvolvimento: 'Status Dev',
  level: 'Level',
};

export const headersActsResponsavel = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Status', width: 15, key: 'status' },
  { text: 'Data Início', width: 15, key: 'dataInicio' },
  { text: 'Data Fim', width: 15, key: 'dataFim' },
  { text: 'Responsável', width: 50, key: 'responsavel' },
];

export const valoresExibidosOffCanvasActsResponsavel: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separadorLog: '',
  separadorPontuacao: '',
  separadorIdentificacao: '',
  separadorFuncionalidade: '',
  separadorObservacoes: '',

  //Específicos
  interfaceSisAf: 'Interface',
  moduloSisAf: 'Módulo',
  tipoTask: 'Tipo de Task',
  responsavel: 'Responsável',
  dataEntrada: 'Data de Início',
  dataFinalizacao: 'Data Finalização',
  diasDev: 'Total de dias',
  funcionalidade: 'Funcionalidade',
  descricao: 'Descrição',
  complexidade: 'Complexidade',
  reaproveitamentoCodigo: 'Reaprov. Código',
  pontosFuncionalidade: 'Level (0 a 100)',
  statusDesenvolvimento: 'Status Dev',
  level: 'Level',
};

export const headersActsTermoAditivo = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Status', width: 15, key: 'status' },
  { text: 'Data DOU', width: 15, key: 'dataDou' },
  { text: 'Tipo de TA', width: 15, key: 'tipoTA' },
  { text: 'Nº DOC SEI', width: 15, key: 'docSei' },
  { text: 'Objeto', width: 50, key: 'objeto' },
];

export const valoresExibidosOffCanvasActsTermoAditivo: Record<string, string> =
  {
    id: 'ID',
    dataRegistro: 'Registro',
    dataAtualizacaoRegistro: 'Última Atualização',
    usuarioRegistro: 'Responsável pelo Registro',
    dataUltimaAtualizacao: 'Última Atualização',
    usuarioAtualizacao: 'Responsável Ult. Atualização',
    dataUltimaVisualizacao: 'Última Visualização',
    usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
    nEdicoes: 'Edições',
    nVisualizacoes: 'Visualizações',
    nVisualizadores: 'Visualizadores',
    observacoes: 'Observações',

    //Separadores
    separadorLog: '',
    separadorPontuacao: '',
    separadorIdentificacao: '',
    separadorFuncionalidade: '',
    separadorObservacoes: '',

    //Específicos
    interfaceSisAf: 'Interface',
    moduloSisAf: 'Módulo',
    tipoTask: 'Tipo de Task',
    responsavel: 'Responsável',
    dataEntrada: 'Data de Início',
    dataFinalizacao: 'Data Finalização',
    diasDev: 'Total de dias',
    funcionalidade: 'Funcionalidade',
    descricao: 'Descrição',
    complexidade: 'Complexidade',
    reaproveitamentoCodigo: 'Reaprov. Código',
    pontosFuncionalidade: 'Level (0 a 100)',
    statusDesenvolvimento: 'Status Dev',
    level: 'Level',
  };

export type ActsTableRow = {
  id: string | number;
  status: string;
  componenteAf: string;
  numeroAct: string;
  fornecedor: string;
  [key: string]: any;
};

export const headersActsCustomTable: CustomTableHeader<ActsTableRow>[] = [
  { text: '', width: 1, key: '', renderable: false },
  {
    text: 'ID',
    width: 5,
    key: 'id',
    fieldType: 'number',
    textAlign: 'center',
  },
  {
    text: 'Status',
    width: 10,
    key: 'status',
    fieldType: 'select',
    renderCell: (value) => renderStatusExecucao(value),
  },
  {
    text: 'Componente AF',
    width: 12,
    key: 'componenteAf',
    fieldType: 'select',
    renderCell: (value) => renderComponenteAF(value),
  },
  {
    text: 'Nº do ACT',
    width: 15,
    key: 'numeroAct',
    fieldType: 'text',
  },
  {
    text: 'Fornecedor',
    width: 30,
    key: 'fornecedor',
    fieldType: 'text',
  },
];
